// extracted by mini-css-extract-plugin
module.exports = {"container":"_24u2FdXIK7YjcbnXX3K4_t"};